import { calculateGPA, getGradeOptions } from '../gpaCalculator.js';

let courseCount = 0;

function renderGradeSelect(id, scale) {
    const grades = getGradeOptions(scale);
    return `<select id="grade-${id}">${grades.map(g => `<option value="${g}">${g}</option>`).join('')}</select>`;
}

function addCourse() {
    courseCount++;
    const scale = document.getElementById('scale').value;
    const container = document.getElementById('coursesContainer');
    const div = document.createElement('div');
    div.className = 'course-row';
    div.id = `course-${courseCount}`;
    div.innerHTML = `
        <input type="text" id="name-${courseCount}" placeholder="Course Name" style="flex:2;">
        ${renderGradeSelect(courseCount, scale)}
        <input type="number" id="credits-${courseCount}" placeholder="Credits" value="3" min="0.5" max="10" step="0.5" style="width:80px;">
        <button class="btn-danger remove-btn" data-id="${courseCount}">✕</button>
    `;
    container.appendChild(div);
}

function calculate() {
    const scale = document.getElementById('scale').value;
    const courses = [];
    for (let i = 1; i <= courseCount; i++) {
        const el = document.getElementById(`course-${i}`);
        if (!el) continue;
        courses.push({
            name: document.getElementById(`name-${i}`).value,
            grade: document.getElementById(`grade-${i}`).value,
            credits: parseFloat(document.getElementById(`credits-${i}`).value) || 0
        });
    }

    const result = calculateGPA(courses, scale);
    if (!result) {
        document.getElementById('results').innerHTML = '<p style="color:#6b7280;">Add courses above to calculate your GPA.</p>';
        return;
    }

    let color = '#dc2626';
    if (result.gpa >= 3.5) color = '#059669';
    else if (result.gpa >= 3.0) color = '#2563eb';
    else if (result.gpa >= 2.0) color = '#d97706';

    document.getElementById('results').innerHTML = `
        <div class="result-card" style="border-color:${color};">
            <p style="margin:0;font-size:0.875rem;text-transform:uppercase;font-weight:600;color:${color};letter-spacing:0.05em;">Cumulative GPA</p>
            <h2 class="result-total" style="color:${color};">${result.gpa.toFixed(2)} / ${result.maxGPA.toFixed(1)}</h2>
            <p class="result-sub">${result.totalCredits} credit hours • ${result.totalQualityPoints} quality points • ${result.percentage}%</p>
        </div>
        <table class="results-table">
            <tr><th>Course</th><th>Grade</th><th>Credits</th><th>Points</th></tr>
            ${result.courses.map(c => `<tr><td>${c.name}</td><td>${c.grade}</td><td>${c.credits}</td><td>${c.qualityPoints.toFixed(1)}</td></tr>`).join('')}
        </table>
    `;
}

document.getElementById('coursesContainer').addEventListener('click', (e) => {
    if (e.target.classList.contains('remove-btn')) {
        document.getElementById(`course-${e.target.getAttribute('data-id')}`).remove();
    }
});

document.getElementById('addCourseBtn').addEventListener('click', addCourse);
document.getElementById('calculateBtn').addEventListener('click', calculate);
document.getElementById('scale').addEventListener('change', () => {
    // Rebuild grade dropdowns when scale changes
    const scale = document.getElementById('scale').value;
    for (let i = 1; i <= courseCount; i++) {
        const el = document.getElementById(`grade-${i}`);
        if (el) {
            const currentVal = el.value;
            const grades = getGradeOptions(scale);
            el.innerHTML = grades.map(g => `<option value="${g}" ${g === currentVal ? 'selected' : ''}>${g}</option>`).join('');
        }
    }
});

// Initialize with 4 courses
for (let i = 0; i < 4; i++) addCourse();
